module.exports = __webpack_public_path__ + "static/img/10.3ced51b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/sp/10.png
// module id = ZB2w
// module chunks = 0